App.namespace.wrap('es6.views.user.venue_reveal_contact_handler', function (options = {}) {
  const {
    _token,
    rfpId,
    enquiryId,
    showPhoneUrl,
    showMailUrl,
  } = options

  const $phoneNumbers = $('.js-phone-number-container');
  const $btnShow = $('.js-show-phone');
  const $inlineMailsTruncated = $('.js-vc-mail--truncated');
  const $inlineMailsTrigger = $('.js-vc-mail--show');
  const $inlineMailsOriginal = $('.js-vc-mail--original');
  const $inlinePhonesTruncated = $('.js-vc-phone--truncated');
  const $inlinePhonesTrigger = $('.js-vc-phone--show');
  const $inlinePhonesOriginal = $('.js-vc-phone--original');

  $inlineMailsTrigger.css('cursor', 'pointer');
  $inlinePhonesTrigger.css('cursor', 'pointer');

  // Inform system about user requesting the phone number
  const sendRevealRequestAjax = (type, position) => {
    const data = {
      rfpId,
      enquiryId,
      position: position || 'default',
      _token
    };
    $.post(type === 'phone' ? showPhoneUrl : showMailUrl, data);
  };

  // Remove Show button and show phone numbers
  function showPhoneNumber() {
    $btnShow.remove();
    $phoneNumbers.removeClass('hidden');

    $inlinePhonesTruncated.remove();
    $inlinePhonesOriginal.show();

    // Inform backend about the event
    sendRevealRequestAjax('phone')
  }

    // Show email address in messenger message

  function showPhones() {
      $inlinePhonesTruncated.remove();
      $inlinePhonesOriginal.show();

      $btnShow.remove();
      $phoneNumbers.removeClass('hidden');

      // Inform backend about the event
      sendRevealRequestAjax('phone', 'message')
  }

  // Show email address in messenger message
  function showMails() {
    $inlineMailsTruncated.remove();
    $inlineMailsOriginal.show();

    // Inform backend about the event
    sendRevealRequestAjax('mail')
  }

  // Click on "show" button next to the shortened number
  $btnShow.click(showPhoneNumber);

  $inlineMailsTrigger.click(showMails);
  $inlinePhonesTrigger.click(showPhones);
});
